import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Route guard for backend permission codes (e.g. LOCATION_READ).
 *
 * Allows when the signed-in user holds the code via the real backend
 * permission set (`hasPerm`, incl. Super Admin bypass) OR via the legacy
 * role-based map (`hasPermission`, where ADMIN holds '*'). This keeps full
 * admins and the dev bypass user in while still gating scoped roles.
 *
 * Usage: `canActivate: [permissionGuard], data: { permission: 'LOCATION_READ' }`.
 */
export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const required = route.data['permission'] as string | undefined;
  const anyOf = route.data['anyPermissions'] as string[] | undefined;
  if (anyOf?.length && !anyOf.some(code => auth.hasPerm(code) || auth.hasPermission(code))) {
    return router.createUrlTree(['/dashboard']);
  }
  if (!required) return true;
  if (auth.hasPerm(required) || auth.hasPermission(required)) return true;
  return router.createUrlTree(['/dashboard']);
};
